export default "__VITE_ASSET__BywHBmJ0__"